import { Component } from '@angular/core';
import { RestApi } from '../auth/rest.api';
import { saveFile } from 'app/app.module';

@Component({
  selector: 'biz-bpm-consume',
  templateUrl: './bpm-consume.component.html',
  styleUrls: ['./bpm-consume.component.scss']
})

export class BpmConsumeComponent {
  public showLoading: boolean;
  public responseError: string;
  private endPoint = 'api/BPU/GetReportBPU';

  constructor(private _restApi: RestApi) { }

  public downloadReport() {
    this.showLoading = true;
    return this._restApi.requestBlob({ url: this.endPoint, body: '', parameters: [] }, 'GET')
      .subscribe({
        next: (result: any) => {
          const date = new Date();
          const fileName: string = this._restApi.getFileNameFromHeaders(result.headers, `CompleteBPUReport_${date.toDateString()}_${date.getTime()}.pdf`);
          if(result.body.type.match('application/pdf')){
            if (navigator.appVersion.toString().indexOf('.NET') > 0) {
              saveFile(new Blob([result.body], { type: 'application/pdf' }), fileName);
            }
            else {
              const bdexUrl = (window.URL || window['webkitURL']).createObjectURL(new Blob([result.body], { type: 'application/pdf' }));
              const anchor = document.createElement('a');
              anchor.download = fileName;
              anchor.href = bdexUrl;
              anchor.click();
            }
          }
          this.showLoading = false;
          return Promise.resolve(result.body);
        },
        error: () => {
          this.showLoading = false;
        }
      });
  }
}
